import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { Specification, SpecificationInput } from '../models/specification.models';

@Injectable({
  providedIn: 'root',
})
export class SpecificationsService {
  constructor(private http: HttpClient) {}

  getSpecificationsForProject(projectId: string): Observable<Specification[]> {
    return this.http
      .get<Specification[]>(`${environment.baseUrl}/projects/${projectId}/specifications`)
      .pipe(catchError(this.handleError<Specification[]>('getSpecificationsForProject')));
  }

  createSpecification(projectId: string, specification: SpecificationInput): Observable<Specification> {
    return this.http
      .post<Specification>(`${environment.baseUrl}/projects/${projectId}/specifications`, specification)
      .pipe(catchError(this.handleError<Specification>('createSpecification')));
  }

  updateSpecification(
    projectId: string,
    specificationId: string,
    specification: SpecificationInput,
  ): Observable<Specification> {
    return this.http
      .put<Specification>(
        `${environment.baseUrl}/projects/${projectId}/specifications/${specificationId}`,
        specification,
      )
      .pipe(catchError(this.handleError<Specification>('updateSpecification')));
  }

  deleteSpecification(projectId: string, specificationId: string): Observable<any> {
    return this.http
      .delete<Specification>(`${environment.baseUrl}/projects/${projectId}/specifications/${specificationId}`)
      .pipe(catchError(this.handleError<any>('deleteSpecification')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
